export const defaultWall = `\
-- running bond
-- every other course is staggered

S >>
S
`
